import { ReactElement } from 'react';
import PerformableGroupForm, { usePerformableGroup } from '~/components/performable/PerformableGroupForm';
import Sections from '~/components/layout/Sections';
import { TenantPackageIncludes } from '~/tenants/common/package';
import { McmOrderContext } from '~/tenants/mcm/model/McmOrder';
import {
  McmDayToNightInclude,
  McmDroneInclude,
  McmDroneTwilightInclude,
  McmMicrositeInclude,
  McmPhotoInclude,
  McmSocialInclude,
  McmVideoInclude, McmVirtualTwilightInclude,
} from '~/tenants/mcm/package/common';
import McmPhotoConfig, { McmPhotoType } from '~/tenants/mcm/performable/photo/McmPhotoConfig';
import McmVideoConfig, { McmVideoType } from '~/tenants/mcm/performable/video/McmVideoConfig';
import McmDroneConfig, { McmDroneType } from '~/tenants/mcm/performable/drone/McmDroneConfig';
import ZodFieldHidden from '~/components/zod/ZodFieldHidden';
import McmVirtualConfig from '~/tenants/mcm/performable/virtual/McmVirtualConfig';

export default function McmPackageEssentialPlusForm(): ReactElement {
  return (
    <Sections>
      <TenantPackageIncludes>
        <McmPhotoInclude />
        <McmDroneInclude type={McmDroneType.VIDEO_PHOTO} />
        <McmVirtualTwilightInclude />
        <McmMicrositeInclude />
      </TenantPackageIncludes>
      <PerformableGroupForm performable={McmPhotoConfig}>
        <ZodFieldHidden name="type" value={McmPhotoType.INTERIOR_EXTERIOR} />
      </PerformableGroupForm>
      <PerformableGroupForm performable={McmDroneConfig}>
        <ZodFieldHidden name="type" value={McmDroneType.VIDEO_PHOTO} />
        <ZodFieldHidden name="daytime" value="true" />
      </PerformableGroupForm>
      <PerformableGroupForm performable={McmVirtualConfig}>
        <ZodFieldHidden name="photos" value="1" />
      </PerformableGroupForm>
    </Sections>
  );
}
